export let routes = [
  {
    path: '/x3-side-teacher',
    name: 'x3-side-teacher',
    component: () => import('@x3/js/side/teacher/teacher.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-teacher-checking',
    name: 'x3-side-teacher-checking',
    component: () => import('@x3/js/side/teacher/teacher-checking.vue'),
    meta: {
      vx_animate: 'none',
    },
  }
];

export let api = {
  xsTeacher(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-teacher',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsTeacherChecking(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-teacher-checking',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
